import styled from 'styled-components';

import { colors } from 'theme/colors';

export const AssessmentTabContainer = styled.div`
  margin: 20px;
`;

export const DataGridStyles = {
  color: colors.text.primary,
  fontSize: '14px',

  height: '440px',

  // remove border from the last row
  '& .MuiDataGrid-row:last-child': {
    '& .MuiDataGrid-cell': {
      border: 'none',
    },
  },

  '& .MuiDataGrid-cell--editing': {
    border: `1px solid ${colors.primary.main}`,
    '& .MuiInputBase-root': {
      fontSize: '14px',
    },
  },

  '& .MuiDataGrid-row--editing': {
    boxShadow: 'none',
  },
};
